"use client"

import { m } from "framer-motion"
import type { ReactNode } from "react"

interface FloatingCardProps {
  children: ReactNode
  delay?: number
  className?: string
}

export default function FloatingCard({ children, delay = 0, className = "" }: FloatingCardProps) {
  return (
    <m.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.8,
        delay,
        type: "spring",
        stiffness: 100,
      }}
      whileHover={{
        y: -10,
        transition: { duration: 0.3 },
      }}
      className={className}
    >
      {children}
    </m.div>
  )
}
